import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var SatelliteDish = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M192 32c0-17.7 14.3-32 32-32 159.1 0 288 128.9 288 288 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-123.7-100.3-224-224-224-17.7 0-32-14.3-32-32zM60.6 220.6l104.1 104.1 28.4-28.4c-.7-2.6-1.1-5.4-1.1-8.3 0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-28.4 28.4 104.1 104.1c14.5 14.5 11.8 38.8-7.3 46.3-23.6 9.2-49.2 14.3-76.1 14.3C93.1 512 0 418.9 0 304c0-26.9 5.1-52.5 14.4-76.1 7.5-19 31.8-21.8 46.3-7.3zM224 96c106 0 192 86 192 192 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7-57.3-128-128-128-17.7 0-32-14.3-32-32s14.3-32 32-32z"
  }));
});
SatelliteDish.displayName = 'SatelliteDish';
export var SatelliteDishDimensions = {
  height: 512,
  width: 512
};